<script lang="ts">
    
    import { createEventDispatcher } from "svelte";
    import { Button, FormGroup } from "sveltestrap";
    import type { Account } from "../../Model/Account";
    import { accountsFactory, accountsService, uuidGenerator } from "../../Services";
import { showNotification } from "../../Services/ui";
    import ControlFeedback from "../ControlFeedback.svelte";
    import ControlLabel from "../ControlLabel.svelte";
    import FormFeedback from "../FormFeedback.svelte";
    import InvalidFeedback from "../InvalidFeedback.svelte";

    export let account: Account;

    const enabledChecboxId = uuidGenerator.createUuid();
    const dispatch = createEventDispatcher();

    let formFeedback: FormFeedback;
    let name: string = '';
    let enabled: boolean = true;

    $: setupForm(account);

    function setupForm(account: Account): void {
        name = account.name.value;
        enabled = account.enabled.value;
    }

    async function onSave(): Promise<void> {
        formFeedback.validate();

        if (!formFeedback.isValid()) {
            return;
        }

        try {
            
            const copy = accountsFactory.createAccount(
                account.id,
                enabled,
                name,
                account.allowedGames.toJSON(),
            );

            await accountsService.saveAccount(copy);

            showNotification({
                type: 'success',
                content: 'Los datos han sido guardados'
            });

            account.enabled.set(enabled);
            account.name.set(name);

            dispatch('saved');

        } catch (error) {
            console.error(error);
        }
    }

</script>

<FormFeedback bind:this={formFeedback}>

    <FormGroup>
        <ControlFeedback let:input let:invalid let:valueMissing>

            <ControlLabel required invalid={input && invalid}>Nombre</ControlLabel>
    
            <input type="text" class="form-control" bind:value={name} required>
    
            <InvalidFeedback show={input && valueMissing}>
                Debe indicar un nombre de cuenta
            </InvalidFeedback>
    
        </ControlFeedback>
    </FormGroup>

    <div class="f-between">
        <div class="form-check">
            <input class="form-check-input" type="checkbox" bind:checked={enabled} id={enabledChecboxId}>
            <label class="form-check-label" for={enabledChecboxId}>Activado</label>
        </div>
        <Button type="button" color="primary" on:click={onSave}>
            Guardar
        </Button>
    </div>

</FormFeedback>
